import axios from "axios";
import {
  USER_VERIFICATION_ATTEMPT,
  USER_VERIFICATION_SUCCESS,
  USER_VERIFICATION_FAILED,
  USER_VERIFICATION_SUBMIT_ATTEMPT,
  USER_VERIFICATION_SUBMIT_SUCCESS,
  USER_VERIFICATION_SUBMIT_FAILED,
} from "../types/userVerificationTypes";
import { config } from "../../config";
import { getDefaultVerificationState } from "../../assets/userVerificationUtils";

const url_api = config.api.godiway;
const axiosOptions = {
  validateStatus: (status) => status >= 200 && status < 600,
  timeout: 120000,
  maxContentLength: Infinity,
  maxBodyLength: Infinity,
};

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
});

const parseApiError = (error, response) => {
  const data = response?.data ?? error?.response?.data;

  if (data && typeof data === "object" && data.body) {
    return data.body;
  }

  const status = response?.status ?? error?.response?.status;
  if (status === 404) {
    return "verification_service_unavailable";
  }

  if (status === 413) {
    return "verification_file_too_large";
  }

  return "try_later";
};

export const defaultVerificationState = getDefaultVerificationState();

export const loadUserVerification = (data) => async (dispatch) => {
  dispatch({ type: USER_VERIFICATION_ATTEMPT });

  try {
    const response = await axios.get(`${url_api}auth/verification`, {
      ...axiosOptions,
      params: { id: data.user_id },
      headers: authHeaders(data.token),
    });

    if (response.data?.status === "Success") {
      dispatch({
        type: USER_VERIFICATION_SUCCESS,
        data: { ...defaultVerificationState, ...response.data.body },
      });
      return;
    }

    dispatch({
      type: USER_VERIFICATION_FAILED,
      error: parseApiError(null, response),
    });
  } catch (error) {
    console.error("loadUserVerification", error);
    dispatch({
      type: USER_VERIFICATION_FAILED,
      error: parseApiError(error),
    });
  }
};

export const submitUserVerification = (data) => async (dispatch) => {
  dispatch({ type: USER_VERIFICATION_SUBMIT_ATTEMPT });

  try {
    const formData = new FormData();
    formData.append("id", data.user_id);
    formData.append("id_type", data.id_type);
    formData.append("id_document", data.id_document);
    formData.append("face_video", data.face_video);
    formData.append("address_document", data.address_document);

    const response = await axios.post(`${url_api}auth/verification`, formData, {
      ...axiosOptions,
      headers: authHeaders(data.token),
    });

    if (response.data?.status === "Success") {
      dispatch({
        type: USER_VERIFICATION_SUBMIT_SUCCESS,
        data: { ...defaultVerificationState, ...response.data.body },
      });
      return { success: true };
    }

    const apiError = parseApiError(null, response);
    dispatch({ type: USER_VERIFICATION_SUBMIT_FAILED, error: apiError });
    return { success: false, error: apiError };
  } catch (error) {
    console.error("submitUserVerification", error);
    const apiError = parseApiError(error);
    dispatch({ type: USER_VERIFICATION_SUBMIT_FAILED, error: apiError });
    return { success: false, error: apiError };
  }
};
